/**
 * Primary navigation, shared by the desktop header and the mobile menu so the
 * two never drift. Destinations are always visible (pages handle the
 * disconnected state themselves); only Portfolio needs an address to point at.
 */
import { routes } from '@/lib/routes';
import { env } from '@/lib/env';
import type { IconName } from '@/components/ui/icons';

export interface NavItem {
  key: string;
  label: string;
  to: string;
  icon: IconName;
  isActive: (pathname: string) => boolean;
  /** Short status pill beside the label (e.g. "Soon" for a coming-soon page). */
  badge?: string;
}

export function getNavItems(portfolioAddress: string | null): NavItem[] {
  const items: NavItem[] = [
    {
      key: 'overview',
      label: 'Overview',
      to: routes.home(),
      icon: 'grid',
      isActive: (p) => p === routes.home(),
    },
  ];

  if (portfolioAddress) {
    items.push({
      key: 'portfolio',
      label: 'Portfolio',
      to: routes.address(portfolioAddress),
      icon: 'briefcase',
      isActive: (p) => p.startsWith('/address/'),
    });
  }

  items.push(
    {
      key: 'stake',
      label: 'Stake',
      to: routes.stake(),
      icon: 'layers',
      isActive: (p) => p === routes.stake(),
    },
    {
      key: 'swap',
      label: 'Swap',
      to: routes.swap(),
      icon: 'swap',
      isActive: (p) => p === routes.swap(),
    }
  );

  // CHIP -> USDC: the money-out step after earning. Only where CHIP is deployed.
  if (env.contracts.chipAddress) {
    items.push({
      key: 'withdraw',
      label: 'Withdraw',
      to: routes.withdraw(),
      icon: 'download',
      isActive: (p) => p === routes.withdraw(),
    });
  }

  // Coming soon; last so the live destinations come first.
  items.push({
    key: 'lending',
    label: 'Lending',
    to: routes.lending(),
    icon: 'landmark',
    isActive: (p) => p === routes.lending(),
    badge: 'Soon',
  });

  return items;
}

export const PLAY_URL = 'https://play.phenompoker.com';
